<div class="panel-shell">
  <header class="panel-header">
    <div class="panel-title text-bold" *ngIf="mode === 'CREATE'">
      {{ "SERVICE_CHARGE.TITLE" | translate }}
    </div>
    <div class="panel-title text-bold" *ngIf="mode === 'EDIT'">
      {{ "SERVICE_CHARGE.EDIT_TITLE" | translate }}
    </div>
    <button
      mat-icon-button
      type="button"
      class="panel-close-btn"
      (click)="close()"
      aria-label="Close panel"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="panel-body">
    <div class="flex-column-center-start">
      <div
        *ngIf="serviceCharge"
        [formGroup]="form"
        class="item-full-width flex-column-start-start"
      >
        <mat-label *ngIf="mode === 'CREATE'" class="label-mat">
          {{ "SERVICE_CHARGE.SELECT_SERVICE_CHARGE" | translate }}
        </mat-label>
        <select2
          class="fxFlex-100p"
          style="width: 100%"
          *ngIf="mode === 'CREATE'"
          overlay="true"
          minCountForSearch="0"
          displaySearchStatus="default"
          styleMode="material"
          [data]="serviceChargeSelect2Data"
          [value]="selectedServiceChargeUuid"
          (update)="onServiceChargeChange($event)"
        >
        </select2>

        <div *ngIf="mode === 'EDIT'" class="my-8 service-charge-name">
          {{ serviceCharge.name }}
        </div>

        <mat-form-field
          [formGroup]="formPrice"
          class="item-full-width fxFlex-100p"
          *ngIf="
            serviceCharge &&
            serviceCharge.multiply_enum !==
              ServiceChargeMultiplyEnum.PERCENTAGE_BY_INVOICE_CATEGORIES
          "
        >
          <mat-label>{{ "GENERIC.PRICE" | translate }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="unit_price"
            autocomplete="nope"
            pattern="^[+-]?[0-9]+([.,][0-9]{1,2})?"
            [(ngModel)]="serviceCharge.unit_price"
            required
          />
          <mat-error *ngIf="formPrice.controls['unit_price'].invalid">
            {{ "GENERIC.INPUT_NUMBER" | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          [formGroup]="formPercent"
          class="item-full-width fxFlex-100p"
          *ngIf="
            serviceCharge &&
            serviceCharge.multiply_enum ===
              ServiceChargeMultiplyEnum.PERCENTAGE_BY_INVOICE_CATEGORIES
          "
        >
          <mat-label>{{ "GENERIC.PERCENTAGE" | translate }}</mat-label>
          <input
            matInput
            formControlName="percent"
            autocomplete="nope"
            type="number"
            [(ngModel)]="serviceCharge.percentage_by"
          />
          <mat-error *ngIf="formPercent.controls['percent'].invalid" class="">
            {{ "GENERIC.INPUT_NUMBER_MINUS_100_100" | translate }}
            {{ "GENERIC.INPUT_NUMBER_NOT_ZERO" | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="item-full-width fxFlex-100p">
          <mat-label>{{ "GENERIC.QUANTITY" | translate }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qty"
            autocomplete="nope"
            pattern="^-?([1-9]\d*)?$"
            [(ngModel)]="serviceCharge.qty"
            required
          />
          <mat-error *ngIf="form.controls['qty'].invalid">
            {{ "GENERIC.INPUT_NUMBER_INTEGER_ONLY" | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div
        class="flex-column-start-start fxFlex-100p"
        *ngIf="
          serviceCharge &&
          serviceCharge.multiply_enum ===
            ServiceChargeMultiplyEnum.PERCENTAGE_BY_INVOICE_CATEGORIES
        "
      >
        <mat-checkbox
          labelPosition="after"
          [(ngModel)]="serviceCharge.has_food"
          [ngModelOptions]="{ standalone: true }"
          >{{ "GENERIC.ROYALTY_FOOD" | translate }}
        </mat-checkbox>
        <mat-checkbox
          labelPosition="after"
          [(ngModel)]="serviceCharge.has_beverage"
          [ngModelOptions]="{ standalone: true }"
        >
          {{ "GENERIC.ROYALTY_BEVERAGE" | translate }}
        </mat-checkbox>
        <mat-checkbox
          labelPosition="after"
          [(ngModel)]="serviceCharge.has_material"
          [ngModelOptions]="{ standalone: true }"
        >
          {{ "GENERIC.ROYALTY_MATERIAL" | translate }}
        </mat-checkbox>
        <mat-checkbox
          labelPosition="after"
          [(ngModel)]="serviceCharge.has_service"
          [ngModelOptions]="{ standalone: true }"
        >
          {{ "GENERIC.ROYALTY_SERVICE" | translate }}
        </mat-checkbox>
        <mat-checkbox
          labelPosition="after"
          [(ngModel)]="serviceCharge.has_delivery"
          [ngModelOptions]="{ standalone: true }"
        >
          {{ "GENERIC.ROYALTY_DELIVERY_FEE" | translate }}
        </mat-checkbox>
      </div>
    </div>

    <div
      *ngIf="
        serviceCharge &&
        serviceCharge.multiply_enum === 'MULTIPLY_BY_DATE_RANGE'
      "
      [formGroup]="formMultiply"
      class="item-full-width flex-column-center-start"
    >
      <mat-form-field style="width: 100%" class="">
        <mat-label>{{ "GENERIC.DATE_START" | translate }}</mat-label>
        <input
          matInput
          [matDatepicker]="eventDateFrom"
          [(ngModel)]="serviceCharge.multiply_date"
          min="1900-01-01"
          formControlName="date"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="eventDateFrom"
        ></mat-datepicker-toggle>
        <mat-datepicker #eventDateFrom></mat-datepicker>

        <mat-error *ngIf="formMultiply.controls['date'].invalid"
          >{{ "GENERIC.DATE_DEFAULT_RANGE_INVALID" | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field style="width: 100%" class="">
        <mat-label>{{ "GENERIC.DATE_END" | translate }}</mat-label>
        <input
          matInput
          [matDatepicker]="eventDateEnd"
          [(ngModel)]="serviceCharge.multiply_date_end"
          min="1900-01-01"
          formControlName="date_end"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="eventDateEnd"
        ></mat-datepicker-toggle>
        <mat-datepicker #eventDateEnd></mat-datepicker>

        <mat-error *ngIf="formMultiply.controls['date_end'].invalid"
          >{{ "GENERIC.DATE_DEFAULT_RANGE_INVALID" | translate }}
        </mat-error>
      </mat-form-field>

      <div class="flex-row-start-start fxFlex-100p">
        <mat-checkbox
          labelPosition="after"
          [(ngModel)]="has_majoration"
          [ngModelOptions]="{ standalone: true }"
          class="mr-12"
        >
          {{ "SERVICE_CHARGE.MAJORATION_FEE" | translate }}
        </mat-checkbox>
        <mat-form-field *ngIf="has_majoration" class="flex-column">
          <mat-label>{{ "SERVICE_CHARGE.MAJORATION_FEE" | translate }}</mat-label>
          <input
            matInput
            type="text"
            autocomplete="nope"
            formControlName="markup"
            pattern="^[+-]?[0-9]+([.,][0-9]{1,2})?"
            [(ngModel)]="serviceCharge.markup"
          />
          <mat-error *ngIf="formMultiply.controls['markup'].invalid">
            {{ "GENERIC.INPUT_NUMBER_0_999999" | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div
      *ngIf="serviceCharge && (mode === 'EDIT' || selectedServiceChargeUuid !== '')"
      class="item-full-width flex-column-start-start mt-16"
    >
      <mat-label class="label-mat mb-4">
        {{ "SERVICE_CHARGE.INTERNAL_NOTE" | translate }}
      </mat-label>
      <p-editor
        #internalNoteEditor
        [(ngModel)]="serviceCharge.internal_note"
        [ngModelOptions]="{ standalone: true }"
        (onTextChange)="onInternalNoteChange($event)"
        [style]="{
          height: '160px',
          width: '100%',
          resize: 'vertical',
          overflow: 'auto',
        }"
      >
        <ng-template pTemplate="header">
          <span class="ql-formats">
            <button class="ql-bold"></button>
            <button class="ql-italic"></button>
            <button class="ql-underline"></button>
            <button class="ql-strike"></button>
          </span>
          <span class="ql-formats">
            <select class="ql-color"></select>
            <select class="ql-background"></select>
          </span>
          <span class="ql-formats">
            <button class="ql-list" value="ordered"></button>
            <button class="ql-list" value="bullet"></button>
            <button class="ql-indent" value="-1"></button>
            <button class="ql-indent" value="+1"></button>
          </span>
          <span class="ql-formats">
            <app-emoji-picker-button
              [editor]="internalNoteEditor"
            ></app-emoji-picker-button>
          </span>
        </ng-template>
      </p-editor>
    </div>

    <div *ngIf="loading" class="flex-row-center-start">
      <mat-spinner [diameter]="40" class="mt-20"></mat-spinner>
    </div>
  </div>

  <footer class="panel-footer gt2-buttons-theme flex-row-center-center">
    <button
      mat-raised-button
      *ngIf="mode === 'CREATE'"
      [disabled]="
        !form.valid ||
        !(formPrice.valid || formPercent.valid) ||
        selectedServiceChargeUuid === ''
      "
      color="accent"
      class="mr-8 ml-8 mt-4 mb-4"
      (click)="onCreateServiceCharge()"
    >
      {{ "GENERIC.SAVE" | translate }}
    </button>
    <button
      mat-stroked-button
      *ngIf="mode === 'CREATE'"
      [disabled]="
        !form.valid ||
        !(formPrice.valid || formPercent.valid) ||
        selectedServiceChargeUuid === ''
      "
      class="mr-8 mt-4 mb-4"
      (click)="onCreateServiceCharge(true)"
    >
      {{ "SERVICE_CHARGE.CREATE_AND_ADD" | translate }}
    </button>
    <button
      mat-raised-button
      *ngIf="mode === 'EDIT'"
      [disabled]="
        form.invalid ||
        loading ||
        (serviceCharge.multiply_enum ===
          ServiceChargeMultiplyEnum.PERCENTAGE_BY_INVOICE_CATEGORIES &&
          formPercent.invalid) ||
        (serviceCharge.multiply_enum !==
          ServiceChargeMultiplyEnum.PERCENTAGE_BY_INVOICE_CATEGORIES &&
          formPrice.invalid) ||
        (serviceCharge.multiply_enum ===
          ServiceChargeMultiplyEnum.MULTIPLY_BY_DATE_RANGE &&
          formMultiply.invalid)
      "
      color="accent"
      class="mr-8 ml-8 mt-4 mb-4"
      (click)="onCreateServiceCharge()"
    >
      {{ "GENERIC.SAVE" | translate }}
    </button>

    <button
      mat-raised-button
      color="primary"
      (click)="close()"
      class="mr-8 ml-8 mt-4 mb-4"
    >
      {{ "GENERIC.CANCEL" | translate }}
    </button>
  </footer>
</div>
